import React from 'react';
import { Tooltip } from 'antd';
import _ from 'lodash';

import StyledCell from './StyledCell';
import TermAggregation from './TermAggregation';
import Flex from '../styled/Flex';

import overflowStyles from './overflow.style';
import { getStringColumns } from '../../utils';
import colors from './theme';

const NUMBER_FIELDS = [];
const DataColumnHeader = ({
	col,
	visibleColumns,
	sortColumn,
	handleSort,
	sortDir,
	aggregations,
}) => (
	<StyledCell
		style={{ background: colors.tableHead, fontWeight: 'bold', width: 200 }}
		height="60"
	>
		<Flex flexDirection="column" style={{ width: '100%' }}>
			<Flex
				justifyContent="space-between"
				alignItems="center"
				wrap="nowrap"
				style={{
					width: '100%',
				}}
			>
				<Flex alignItems="center" wrap="nowrap" style={{ cursor: 'pointer' }}>
					<Tooltip title={col} trigger="click">
						<span
							style={{
								maxWidth: 120,
								...overflowStyles,
							}}
						>
							{col}
						</span>
					</Tooltip>
				</Flex>

				<Flex alignItems="center">
					<TermAggregation field={col} visibleColumns={visibleColumns} />
					<button
						type="button"
						onClick={() => {
							if (getStringColumns(visibleColumns).indexOf(col) > -1) {
								handleSort(`${col}.keyword`);
							} else {
								handleSort(col);
							}
						}}
						style={{
							outline: 0,
							height: '15px',
							width: '15px',
							border: 0,
							cursor: 'pointer',
							background: 'none',
						}}
					>
						{sortColumn.split('.')[0] === col ? (
							<>
								<>
									{sortDir === 'asc' && (
										<i
											className="fa fa-caret-up"
											css={{
												fontSize: 15,
											}}
										/>
									)}
								</>
								<>
									{sortDir === 'desc' && (
										<i
											className="fa fa-caret-down"
											css={{
												fontSize: 15,
											}}
										/>
									)}
								</>
							</>
						) : (
							<i
								className="fa fa-sort"
								css={{
									fontSize: 15,
								}}
							/>
						)}
					</button>
				</Flex>
			</Flex>
			<Flex alignItems="center">
				{aggregations &&
					!_.isEmpty(aggregations) &&
					aggregations[col] &&
					aggregations[col].value && (
						<Tooltip title={(aggregations[col] || {}).value || 0} trigger="click">
							<Flex
								justifyContent="space-between"
								style={{ marginTop: 4, width: '100%' }}
							>
								{NUMBER_FIELDS.indexOf(col) > -1 ? 'Total' : 'Count'}
								<i
									style={{
										cursor: 'pointer',
										fontWeight: 'normal',
										...overflowStyles,
									}}
								>
									{aggregations[col].value}
								</i>
							</Flex>
						</Tooltip>
					)}
			</Flex>
		</Flex>
	</StyledCell>
);

export default DataColumnHeader;
